<template>
    <v-card class="mx-auto mb-8" width="1150" elevation="16" >
        <v-img
        cover
        height="250"
        :src="post.image"
        ></v-img>
        <v-card-item>
            <v-card-subtitle>{{ post.date }}</v-card-subtitle>
            <v-card-title>{{ post.title }}</v-card-title>
        </v-card-item>
        <v-card-text>{{ post.content }}</v-card-text>
    </v-card>
</template>

<script>
  export default {
    name: 'BlogPost',
    props: ['post'],
    data() {
      return {
        
      }
    },
    methods: {
        
    }
  }
</script>